import { FloorPlan, FloorPlanTable } from "@lemmonhq/types";

/**
 * Deletes a floor plan item from the floor plan
 * @param floorPlan - The current floor plan
 * @param itemId - The ID of the item to delete
 * @returns Updated floor plan with the item removed
 */
export const deleteFloorPlanItem = (
  floorPlan: FloorPlan,
  itemId: string,
): FloorPlan => {
  return {
    ...floorPlan,
    plan: floorPlan.plan.filter((item: FloorPlanTable) => item.id !== itemId),
  };
};

/**
 * Updates a floor plan item in the floor plan
 * @param floorPlan - The current floor plan
 * @param updatedItem - The updated floor plan item
 * @returns Updated floor plan with the item modified
 */
export const updateFloorPlanItem = (
  floorPlan: FloorPlan,
  updatedItem: FloorPlanTable,
): FloorPlan => {
  return {
    ...floorPlan,
    plan: floorPlan.plan.map((item: FloorPlanTable) =>
      item.id === updatedItem.id ? updatedItem : item,
    ),
  };
};
